import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class TitleSanta extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.body = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TitleSantaBody_Idle, this).setOrigin(0);

    this.arm = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TitleSantaArmWave, this).setOrigin(.1, .9);
    this.arm.x = 102;
    this.arm.y = 112;
    this.arm.setVisible(false);
  }

  goIdle() {
    this.arm.setVisible(false);
    this.body.setFrame(UIAssetKeys._TitleSantaBody_Idle);
  };

  doWave() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._hoho, this.scene, 1, false, 0.5);

    this.arm.setVisible(true);
    this.body.setFrame(UIAssetKeys._TitleSantaBody_Wave);

    this.arm.angle = -8;
    ABCyaPhaser.Tweens.addTween(this.arm, 400, { angle: 10, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
  };
}